import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClaimSearchComponent } from '@modules/claims/modules/claim-search/components/claim-search/claim-search.component';
import { MaterialModule } from '@core/material/material.module';
import { RcpCommonLibraryModule } from '@core/modules/rcp-common-library/rcp-common-library.module';
import { PipesModule } from '@core/pipes/pipes.module';
import { LayoutHelpersModule } from '@layouts/layout-helpers/layout-helpers.module';
import { RouterOutlet } from '@angular/router';
import { ClaimSearchRoutingModule } from '@modules/claims/modules/claim-search/claim-search-routing.module';
import { ClaimSearchNavigationModule } from '@modules/claims/modules/claim-search/modules/claim-search-navigation/claim-search-navigation.module';
import { ClaimSearchFilterModule } from '@modules/claims/modules/claim-search/modules/claim-search-filter/claim-search-filter.module';
import { ClaimSearchGridModule } from '@modules/claims/modules/claim-search/modules/claim-search-grid/claim-search-grid.module';
import { CommonInputsModule } from '@modules/common/modules/inputs/common-inputs/common-inputs.module';
import { FormModule } from 'rcp-common-lib';
import { GridComponent } from 'rcp-common-lib';
import { StalledClaimFilterComponent } from '@modules/claims/components/stalled-claim-filter/stalled-claim-filter.component';

@NgModule({
    declarations: [ClaimSearchComponent],
    exports: [ClaimSearchComponent],
    imports: [
        CommonModule,
        MaterialModule,
        RcpCommonLibraryModule,
        PipesModule,
        LayoutHelpersModule,
        RouterOutlet,
        ClaimSearchRoutingModule,
        ClaimSearchNavigationModule,
        ClaimSearchFilterModule,
        ClaimSearchGridModule,
        CommonInputsModule,
        FormModule,
        GridComponent,
        StalledClaimFilterComponent,
    ],
})
export class ClaimSearchModule {}
